import { render } from "./FormItem.vue?vue&type=template&id=d02dc7f6"
import script from "./FormItem.vue?vue&type=script&lang=ts"
export * from "./FormItem.vue?vue&type=script&lang=ts"

import "./FormItem.vue?vue&type=style&index=0&id=d02dc7f6&lang=stylus"
script.render = render

export default script